// Brand constants for Native Plant Garden Planner
export const BRAND = {
  APP_NAME: "Native Plant Garden Planner",
  APP_TAGLINE: "Personalized native plant plans for your yard or balcony — made simple.",
  
  // Tier names
  TIER_FREE: "Free Explorer",
  TIER_CORE: "Planner Core",
  TIER_PLUS: "Planner Plus",
  
  // SEO
  META_TITLE: "Native Plant Garden Planner | Personalized Native Plant Plans for Your Yard or Balcony",
  META_DESCRIPTION: "Upload a photo and get a personalized native plant garden plan with zone-by-zone layouts, month-by-month guidance, HOA-friendly options, and printable PDFs.",
  
  // OpenGraph
  OG_TITLE: "Native Plant Garden Planner",
  OG_IMAGE: "/og-native-plant-garden-planner.png",
  
  // Legal
  COPYRIGHT: `© ${new Date().getFullYear()} Native Plant Garden Planner. All rights reserved.`,
  DISCLAIMER: "Native Plant Garden Planner is an educational planning tool. Plant recommendations are based on general regional data and should be verified for local conditions before installation. This is not professional landscaping, environmental, or legal advice. No guarantees of plant survival or outcomes.",
  DISCLAIMER_SHORT: "Native Plant Garden Planner is an educational planning tool. Plant recommendations are based on general regional data and should be verified for local conditions before installation.",
} as const;
